import $ from 'jquery';
import 'slick-carousel';
import Modal from './modal';

class ModalAboutSlider extends Modal {
  constructor() {
    super();
    this.toggles = [...this.page.querySelectorAll(`.about__slider-control`)];
    this.sliders = {
      [`2008`]: this.page.querySelector(`.js-year-2008-slider`),
      [`2018`]: this.page.querySelector(`.js-year-2018-slider`)
    };
    this.slider = null;
  }

  init() {
    super.createModal();
    this.bindHandlers();
    this.createSliderWrap();
  };

  createSliderWrap() {
    super.addLayout(`<div class="modal__wrap" id="about-year-slider"></div>`);
  };

  createSlider(year) {
    const container = this.page.querySelector(`#about-year-slider`);
    const sliderLayout = this.sliders[year];

    container.innerHTML = ``;
    container.appendChild(sliderLayout.content.cloneNode(true));
    this.slider = container.querySelector(`#about-slider-${year}`);
    this.initSlider();
  };

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
  };

  initSlider() {
    $(this.slider).slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      useCSS: false
    });
  };

  bindHandlers() {
    this.toggles.forEach((toggle) => {
      toggle.addEventListener(`click`, ({target}) => {
        this.createSlider(target.dataset.year);
        $(this.slider).slick(`slickGoTo`, 0, true);
        this.toggleModal(true);
      });
    });
  }
}

const modalAboutSlider = new ModalAboutSlider();

export default modalAboutSlider;
